import React from "react";
import classnames from "classnames";

import styles from "./Content.module.scss";

export const Content = ({ className, ...props }) => (
  <div className={classnames(className, styles.content)} {...props} />
);

export default Content;
